import en from "./locales/en";
webix.i18n.kanban = en;